export const enum Modules {
  MILDEW = 1,
  AGRONOMICS = 2,
  AMBIENT_CLIMATE = 3,
  SOIL_CLIMATE = 4,
  AUTOMATION = 5,
}
